import { Mapper } from '../../../common/ddd/mapper.base';
import { formatDeviationPrefix } from '../../../common/utils/format-deviation.util';
import { AccountSentimentReportAverageSummaryAggregateRoot } from '../../../core/domain/aggregates/sentiment/account-sentiment-report-average-summary.aggregate-root';
import { GetAccountSentimentReportAverageSummaryResponseDto } from '../../../interface/dtos/sentiment/get-account-sentiment-report-average-summary.response.dto';

export type IAccountSentimentReportAverageSummaryAggregateRootMapper = Mapper<
  AccountSentimentReportAverageSummaryAggregateRoot,
  GetAccountSentimentReportAverageSummaryResponseDto
>;

export class AccountSentimentReportAverageSummaryAggregateRootMapper
  implements
    Omit<IAccountSentimentReportAverageSummaryAggregateRootMapper, 'toDomain'>
{
  toResponse(
    entity: AccountSentimentReportAverageSummaryAggregateRoot
  ): GetAccountSentimentReportAverageSummaryResponseDto {
    return AccountSentimentReportAverageSummaryAggregateRootMapper.toResponse(
      entity
    );
  }

  static toResponse(
    entity: AccountSentimentReportAverageSummaryAggregateRoot
  ): GetAccountSentimentReportAverageSummaryResponseDto {
    return {
      averageRating: Number(entity.averageScore.toFixed(1)),
      averageRatingDeviation: `${formatDeviationPrefix(
        entity.averageScoreDeviation
      )}${entity.averageScoreDeviation.toFixed(1)}`,
    };
  }
}
